import jsSHA from 'jssha';

interface ChallengeResult {
  challengeResult: number[] | number;
  challengeResult2: number;
}

export interface ChallengeBody {
  challenge: string;
  difficulty: string;
  id: string;
  maxTries: string;
  script: string;
}

export const performPow = ({ challenge, difficulty, id, maxTries, script }: ChallengeBody) => {
  const challengeResult: ChallengeResult = {
    challengeResult: 0,
    challengeResult2: 0
  };

  // eslint-disable-next-line no-new-func
  const proofOfWork = new Function(script + 'return proofOfWork')();
  window.jsSHA = jsSHA;
  challengeResult.challengeResult = proofOfWork(challenge, difficulty, maxTries);
  delete window.jsSHA;
  if (challengeResult.challengeResult instanceof Array) {
    [challengeResult.challengeResult, challengeResult.challengeResult2] =
      challengeResult.challengeResult;
  }

  return JSON.stringify({ challenge, id, ...challengeResult });
};
